import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import {
  IUserPermission,
  IUsersSearchRequest,
} from "../model/interface/userPermission";

export const createUserPermission = (userPermission: IUserPermission) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_USERPERMISSION}`,
    userPermission,
    {}
  );
};

export const updateUserPermission = (userPermission: IUserPermission) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_USERPERMISSION}`,
    userPermission,
    {}
  );
};

export const deleteUserPermission = (userId: number, permissionId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_USERPERMISSION, {
    params: {
      userId: userId,
      permissionId: permissionId,
    },
  });
};

export const getAllUsers = (
  filter: IUsersSearchRequest,
  orderByColumn: string,
  sortBy: string,
  pageSize: number,
  pageNumber: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERPERMISSION_GETALLUSERS}`,
    {
      params: {
        Username: filter.username,
        UserId: filter.userId,
        Schoolname: filter.schoolName,
        PageNumber: pageNumber,
        PageSize: pageSize,
        SortDir: sortBy,
        OrderByColumn: orderByColumn,
      },
    }
  );
};

export const getUserPermissionByuserId = (userId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERPERMISSION_BY_USERID.replace(
      "{userId}",
      userId.toString()
    )}`,
    {}
  );
};

export const getAllUserPermissionsByuserId = (userId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERPERMISSION_GETALLBY_USERID.replace(
      "{userId}",
      userId.toString()
    )}`,
    {}
  );
};

export const getAuthUserPermissionsByuserId = (userId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERPERMISSION_GETAUTHPERMISSIONS_BY_USERID.replace(
      "{userId}",
      userId.toString()
    )}`,
    {}
  );
};

export const createUserGroupPermission = (
  userId: number,
  permissionGroupId: number
) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_USERGROUPPERMISSION}`,
    {
      UserId: userId,
      PermissionGroupId: permissionGroupId,
    },
    {}
  );
};

export const deleteUserGroupPermission = (
  userId: number,
  permissionGroupId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_USERGROUPPERMISSION,
    {
      params: {
        userId: userId,
        permissionGroupId: permissionGroupId,
      },
    }
  );
};

export const getUserGroupPermissionByuserId = (userId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_USERGROUPPERMISSION_BY_USERID.replace(
      "{userId}",
      userId.toString()
    )}`,
    {}
  );
};
